import React, { useEffect } from "react";
// import { Route, Router } from "react-router";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home/Home";
import Cloud from "./pages/services/cloud/Cloud";
import { RouteEnum } from "./utils/constants";
import DataAnalysis from "./pages/services/dataAnalysis/DataAnalysis";
import DigitalMarketing from "./pages/digitalMarketing/DigitalMarketing";
import UserExperienceDesign from "./pages/services/userExperienceDesign/UserExperienceDesign";
import Agile from "./pages/services/agile/Agile";
import Devops from "./pages/services/devops/Devops";
import QualityAssuranceProcess from "./pages/services/qualityAssuranceProcess/QualityAssuranceProcess";
import ApplicationInfrastructureOptimisation from "./pages/services/applicationInfrastructureOptimisation/ApplicationInfrastructureOptimisation";
import Banking from "./pages/industries/banking/Banking";
import Health from "./pages/industries/health/Health";
import Education from "./pages/industries/eduction/Education";
import ConsumersTechnology from "./pages/industries/consumersTechnology/ConsumersTechnology";
import EnterpriseTechnology from "./pages/industries/enterpriseTechnology/EnterpriseTechnology";
import ContactUs from "./pages/contactUs/ContactUs";
import ScrollToTop from "./utils/useScrollToTop";
import Blog from "./pages/blog/Blog";
import BlogDetail from "./pages/blog/BlogDetail";
import InformationStrategyAndGovernance from "./pages/services/informationStrategyAndGovernance/InformationStrategyAndGovernance";
import AutomationSolutions from "./pages/services/automationSolutions/AutomationSolutions";
import AOS from "aos";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ApplicationManagedServices from "./pages/services/applicationManagedServices/ApplicationManagedServices";
import BusinessProcessManagement from "./pages/services/businessProcessManagement/BusinessProcessManagement";
import ApplicationDevelopmentAndManagement from "./pages/services/applicationDevelopmentAndManagement/ApplicationDevelopmentAndManagement";
import BiAnnualSecondarySchoolChallange from "./pages/services/biAnnualSecondarySchoolChallange/BiAnnualSecondarySchoolChallange";
import ComputerTrainingScholarshipProgramme from "./pages/services/computerTrainingScholarshipProgramme/ComputerTrainingScholarshipProgramme";
import About from "./pages/services/about/About";
import BuildProject from "./pages/buildProject/BuildProject";
import BlogCategory from "./pages/blog/blogCategory";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <Router>
        <ScrollToTop>
          <Routes>
            {ROUTES.map((route, key) => (
              <Route key={key} {...route} />
            ))}
          </Routes>
        </ScrollToTop>
      </Router>
    </React.Suspense>
  );
}

export default App;

const ROUTES = [
  { path: "/", element: <Home /> },
  { path: RouteEnum.CLOUD, element: <Cloud /> },
  { path: RouteEnum.DIGITAL_ANALYTICS, element: <DataAnalysis /> },
  { path: RouteEnum.DIGITAL_MARKETING, element: <DigitalMarketing /> },
  { path: RouteEnum.USER_EXPERIENCE_DESIGN, element: <UserExperienceDesign /> },
  { path: RouteEnum.AGILE, element: <Agile /> },
  { path: RouteEnum.DEVOPS, element: <Devops /> },
  {
    path: RouteEnum.QUALITY_ASSURANCE_STRATEGY_AND_PROCESS,
    element: <QualityAssuranceProcess />,
  },
  {
    path: RouteEnum.APPLICATION_AND_INFRASTRUCTURE_OPTIMIZATION,
    element: <ApplicationInfrastructureOptimisation />,
  },
  { path: RouteEnum.BANKING, element: <Banking /> },
  { path: RouteEnum.HEALTH, element: <Health /> },
  { path: RouteEnum.BLOG_DETAIL, element: <BlogDetail /> },
  { path: RouteEnum.BLOG_CATEGORY, element: <BlogCategory /> },
  { path: RouteEnum.BLOG, element: <Blog /> },
  { path: RouteEnum.EDUCATION, element: <Education /> },
  { path: RouteEnum.CONSUMER_TECHNOLOGY, element: <ConsumersTechnology /> },
  { path: RouteEnum.BUILD_PROJECT, element: <BuildProject /> },
  {
    path: RouteEnum.INFORMATION_STRATEGY_AND_GOVERNANCE,
    element: <InformationStrategyAndGovernance />,
  },
  { path: RouteEnum.AUTOMATION, element: <AutomationSolutions /> },
  { path: RouteEnum.ENTERPRISES_TECHNOLOGY, element: <EnterpriseTechnology /> },
  { path: RouteEnum.CONTACT_US, element: <ContactUs /> },
  { path: RouteEnum.ABOUT_US, element: <About /> },
  {
    path: RouteEnum.APPLICATION_MANAGED_SERVICES,
    element: <ApplicationManagedServices />,
  },
  {
    path: RouteEnum.BUSINESS_PROCESS_MANAGEMENT,
    element: <BusinessProcessManagement />,
  },
  {
    path: RouteEnum.APPLICATION_DEVELOPMENT_AND_MANAGEMENT,
    element: <ApplicationDevelopmentAndManagement />,
  },
  {
    path: RouteEnum.BIANNUAL_SECONDARY_SCHOOL_CODING_CHALLENGE,
    element: <BiAnnualSecondarySchoolChallange />,
  },
  {
    path: RouteEnum.COMPUTER_TRAINING_SCHOLARSHIP_PROGRAMME,
    element: <ComputerTrainingScholarshipProgramme />,
  },
  {
    path: RouteEnum.EMPLOYEE_TRAINING_AND_MICROLEARNING,
    element: <ComputerTrainingScholarshipProgramme />,
  },
];
